module.exports = __webpack_public_path__ + "img/icon-dry.4083c6ed.svg";